import { BaseService } from '../../../../core/services/base.service';
import { Staff } from '../../interfaces/institution/staff/staff.interface';
import { Observable } from 'rxjs';
import { StaffSearchParam } from '../../interfaces/institution/staff/staff-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

export abstract class StaffService extends BaseService<Staff> {
    findAll(searchParam: StaffSearchParam): Observable<PageResponse<Staff>> { throw new Error('Not implemented'); }
    find(id: string): Observable<Staff> { throw new Error('Not implemented'); }
    create(data: Partial<Staff>): Observable<Staff> { throw new Error('Not implemented'); }
    update(id: string, data: Partial<Staff>): Observable<Staff> { throw new Error('Not implemented'); }
    delete(id: string): Observable<void> { throw new Error('Not implemented'); }
    inviteStaff(staff: Partial<Staff>[]): Observable<any> { throw new Error('Not implemented'); }
    uploadStaffCSV(institutionId: string, file: File): Observable<Staff[]> { throw new Error('Not implemented'); }
    updateStatus(id: string, status: boolean): Observable<void> { throw new Error('Not implemented'); }
    updatePassword(uniqueId: string, password: string): Observable<void> { throw new Error('Not implemented'); }
}
